import React from 'react'
import Text from '@amzn/meridian/text'
import Column from '@amzn/meridian/column'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { IEmptyStateProps } from '../types'
import {
    EMPTY_STATE_NO_NOTIFICATIONS,
    EMPTY_STATE_ALL_CAUGHT_UP,
    EMPTY_STATE_DEFAULT,
} from '../constants'
import './EmptyState.scss'

/**
 * EmptyState Component
 *
 * Displays appropriate empty state message when no notifications match current filter and tab combination.
 * Provides different messages based on context to help users understand why no notifications are shown.
 */
export const EmptyState: React.FC<IEmptyStateProps> = ({ context }) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    const getMessageStringId = (): string => {
        switch (context) {
        case 'no-notifications':
            return EMPTY_STATE_NO_NOTIFICATIONS
        case 'all-caught-up':
            return EMPTY_STATE_ALL_CAUGHT_UP
        default:
            return EMPTY_STATE_DEFAULT
        }
    }

    return (
    <Column
      alignmentHorizontal="center"
      spacingInset="500 400"
      className="empty-state"
      data-testid="empty-state"
    >
      <Text>{t(bundle, getMessageStringId())}</Text>
    </Column>
    )
}
